export default "__VITE_ASSET__ygV4XgOu__"